import * as Yup from "yup";

export const landingValidationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  country: Yup.string().required("Country is required"),
  howDidYouHear: Yup.string(),
  documentReferrer: Yup.string(),
  zipCode: Yup.string().when("country", {
    is: "US",
    then: () => Yup.string().required("Zip Code is required for US"),
  }),
  referrerName: Yup.string().when("howDidYouHear", {
    is: "referral",
    then: () => Yup.string().required("Referral name is required"),
  }),
  referrerEmail: Yup.string().when("howDidYouHear", {
    is: "referral",
    then: () =>
      Yup.string()
        .email("Invalid referral email")
        .required("Referral email is required"),
  }),
  otherDetails: Yup.string().when("howDidYouHear", {
    is: "other",
    then: () => Yup.string().required("Please provide details"),
  }),
});
